import React, { Component } from "react";
import Swal from "sweetalert2";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { TabView, TabPanel } from "primereact/tabview";
import { calculateDaysBetweenDate } from "../../../../utils/utils";
import { restoreLead } from "../../../../services/crm/leadService";
import { restoreCustomer } from "../../../../services/sales/customerService";
import { restoreOutlet } from "../../../../services/sales/outletService";
import { restoreItem } from "../../../../services/inventory/itemService";
import { restoreVendor } from "../../../../services/inventory/vendorService";
import { restoreWarehouse } from "../../../../services/inventory/warehouseService";
import { restoreUser } from "../../../../services/usersService";
import { getRecycleBin } from "../../../../services/commons";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { Badge } from "react-bootstrap";
import withGlobalData from "../../common/withGlobalData";
import { DateTime } from "luxon";
class RecycleBin extends Component {
  state = {
    reload: this.props.globalData.reload,
    customers: [],
    leads: [],
    outlets: [],
    warehouses: [],
    items: [],
    vendors: [],
    customerDetailColumn: [
      {
        header: "Contact Name",
        field: "contactName",
        type: "string",
      },
      {
        header: "Position",
        field: "position",
        type: "string",
      },
      {
        header: "Website",
        field: "website",
        type: "string",
      },
      {
        header: "Email",
        field: "contactEmail",
        type: "string",
      },
      {
        header: "Industry Type",
        field: "industryTypeName",
        type: "string",
      },
      {
        header: "Business Size",
        field: "businessSizeName",
        type: "string",
      },
      {
        header: "Source",
        field: "sourceName",
        type: "string",
      },
      {
        header: "Address",
        field: "address",
        type: "string",
      },
      {
        header: "Province / State",
        field: "province",
        type: "string",
      },
      {
        header: "Country",
        field: "countryName",
        type: "string",
      },
      {
        header: "Postal Code",
        field: "postalCode",
        type: "string",
      },
      {
        header: "Receivable Account",
        field: "receivableAccountName",
        type: "string",
      },
      {
        header: "Lead ID",
        field: "leadID",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
    leadDetailColumn: [
      {
        header: "Customer Group",
        field: "customerGroupName",
        type: "string",
      },
      {
        header: "Position",
        field: "position",
        type: "string",
      },
      {
        header: "Website",
        field: "website",
        type: "string",
      },
      {
        header: "Email",
        field: "contactEmail",
        type: "string",
      },
      {
        header: "Industry Type",
        field: "industryTypeName",
        type: "string",
      },
      {
        header: "Business Size",
        field: "businessSizeName",
        type: "string",
      },
      {
        header: "Source",
        field: "sourceName",
        type: "string",
      },
      {
        header: "Priority",
        field: "priorityName",
        type: "string",
      },
      {
        header: "Address",
        field: "address",
        type: "string",
      },
      {
        header: "Province / State",
        field: "province",
        type: "string",
      },
      {
        header: "Country",
        field: "countryName",
        type: "string",
      },
      {
        header: "Postal Code",
        field: "postalCode",
        type: "string",
      },
      {
        header: "Description",
        field: "description",
        type: "string",
      },
      {
        header: "Customer ID",
        field: "customerID",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
    outletDetailColumn: [
      {
        header: "Email",
        field: "addressEmail",
        type: "string",
      },
      {
        header: "Thermal Printer Size",
        field: "thermalPrinterSizeName",
        type: "string",
      },
      {
        header: "Address",
        field: "address",
        type: "string",
      },
      {
        header: "Province / State",
        field: "province",
        type: "string",
      },
      {
        header: "Country",
        field: "countryName",
        type: "string",
      },
      {
        header: "Postal Code",
        field: "postalCode",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
    warehouseDetailColumn: [
      {
        header: "Email",
        field: "addressEmail",
        type: "string",
      },
      {
        header: "Address",
        field: "address",
        type: "string",
      },
      {
        header: "Province / State",
        field: "province",
        type: "string",
      },
      {
        header: "Country",
        field: "countryName",
        type: "string",
      },
      {
        header: "Postal Code",
        field: "postalCode",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
    itemDetailColumn: [
      {
        header: "Category",
        field: "categoryName",
        type: "string",
      },
      {
        header: "Sub Category",
        field: "subCategoryName",
        type: "string",
      },
      {
        header: "Item Category",
        field: "itemCategoryName",
        type: "string",
      },
      {
        header: "Barcode",
        field: "barcode",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
    vendorDetailColumn: [
      {
        header: "Contact Name",
        field: "contactName",
        type: "string",
      },
      {
        header: "Position",
        field: "position",
        type: "string",
      },
      {
        header: "Website",
        field: "website",
        type: "string",
      },
      {
        header: "Email",
        field: "contactEmail",
        type: "string",
      },
      {
        header: "Industry Type",
        field: "industryTypeName",
        type: "string",
      },
      {
        header: "Business Size",
        field: "businessSizeName",
        type: "string",
      },
      {
        header: "Source",
        field: "sourceName",
        type: "string",
      },
      {
        header: "Address",
        field: "address",
        type: "string",
      },
      {
        header: "Province / State",
        field: "province",
        type: "string",
      },
      {
        header: "Country",
        field: "countryName",
        type: "string",
      },
      {
        header: "Postal Code",
        field: "postalCode",
        type: "string",
      },
      {
        header: "Payable Account",
        field: "payableAccountName",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
    userDetailColumn: [
      {
        header: "Phone Number",
        field: "phone",
        type: "string",
      },
      {
        header: "Email",
        field: "email",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };

  componentDidMount() {
    this.getRecycleBinData();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getRecycleBinData();
      this.setState({ reload: globalData.reload });
    }
  }

  async getRecycleBinData() {
    const response = await getRecycleBin();
    const { data, auth } = response.data;
    const {
      customers,
      leads,
      outlets,
      warehouses,
      items,
      vendors,
      users,
    } = data;
    this.setState({
      customers,
      leads,
      outlets,
      warehouses,
      items,
      vendors,
      users,
      auth,
    });
  }

  render() {
    const {
      customers,
      leads,
      outlets,
      warehouses,
      items,
      vendors,
      users,
      auth,
      customerDetailColumn,
      leadDetailColumn,
      outletDetailColumn,
      warehouseDetailColumn,
      itemDetailColumn,
      vendorDetailColumn,
      userDetailColumn,
    } = this.state;

    const actionButtons = [];
    actionButtons.push({
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        this.props.history.push("/menu");
      },
    });
    return (
      <React.Fragment>
        <PageSubHeader
          title="Recycle Bin"
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/common/recyclebin",
              title: "Recycle Bin",
              active: true,
            },
          ]}
          actionButtons={actionButtons}
        />
        <ContentLayout>
          <span className="notice-layout">
            <i className="fas fa-info-circle"></i> Any deleted Master Data will
            remain in Recycle Bin for up to 1 year before automatically
            permanently deleted
          </span>
          <div className="tabview">
            <div className="card">
              <TabView className="tabview" scrollable>
                <TabPanel header="Customers" rightIcon="fas fa-user-tag">
                  <CustomDataTable
                    data={customers}
                    dataDetailColumns={customerDetailColumn}
                    onRefreshData={() => {
                      this.getRecycleBinData();
                    }}
                    columns={[
                      {
                        header: "Customer ID",
                        field: "ID",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Deleted Status",
                        field: "deletedStatus",
                        body: (rowData) => (
                          <React.Fragment>
                            <Badge variant="danger">Soft Deleted</Badge>
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Customer Group",
                        field: "customerGroupName",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Customer Name",
                        field: "customerName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.customerName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Phone Number",
                        field: "contactPhone",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.contactPhone}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "City",
                        field: "city",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.city}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Permanently Deleted In",
                        field: "DeletedAt",
                        body: (rowData) => (
                          <React.Fragment>
                            {calculateDaysBetweenDate(
                              DateTime.fromISO(rowData.DeletedAt).plus({
                                years: 1,
                              }),
                              DateTime.now()
                            )}{" "}
                            Days
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Actions",
                        body: (rowData) => (
                          <React.Fragment>
                            <BootstrapTooltip title="Restore Customer">
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.handleRestoreCustomer(rowData);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-restore"></i>
                              </button>
                            </BootstrapTooltip>
                          </React.Fragment>
                        ),
                        sortable: false,
                      },
                    ]}
                  />
                </TabPanel>
                <TabPanel header="Leads" rightIcon="fas fa-user-check">
                  <CustomDataTable
                    data={leads}
                    dataDetailColumns={leadDetailColumn}
                    onRefreshData={() => {
                      this.getRecycleBinData();
                    }}
                    columns={[
                      {
                        header: "Lead ID",
                        field: "ID",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Deleted Status",
                        field: "deletedStatus",
                        body: (rowData) => (
                          <React.Fragment>
                            <Badge variant="danger">Soft Deleted</Badge>
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Lead Name",
                        field: "leadName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.leadName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Contact Name",
                        field: "contactName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.contactName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Phone Number",
                        field: "contactPhone",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.contactPhone}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "City",
                        field: "city",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.city}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Permanently Deleted In",
                        field: "DeletedAt",
                        body: (rowData) => (
                          <React.Fragment>
                            {calculateDaysBetweenDate(
                              DateTime.fromISO(rowData.DeletedAt).plus({
                                years: 1,
                              }),
                              DateTime.now()
                            )}{" "}
                            Days
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Actions",
                        body: (rowData) => (
                          <React.Fragment>
                            <BootstrapTooltip title="Restore Lead">
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.handleRestoreLead(rowData);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-restore"></i>
                              </button>
                            </BootstrapTooltip>
                          </React.Fragment>
                        ),
                        sortable: false,
                      },
                    ]}
                  />
                </TabPanel>
                <TabPanel header="Outlets" rightIcon="fas fa-store">
                  <CustomDataTable
                    data={outlets}
                    dataDetailColumns={outletDetailColumn}
                    onRefreshData={() => {
                      this.getRecycleBinData();
                    }}
                    columns={[
                      {
                        header: "Outlet ID",
                        field: "ID",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Deleted Status",
                        field: "deletedStatus",
                        body: (rowData) => (
                          <React.Fragment>
                            <Badge variant="danger">Soft Deleted</Badge>
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Outlet Name",
                        field: "outletName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.outletName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Phone Number",
                        field: "addressPhone",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.addressPhone}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "City",
                        field: "city",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.city}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Currency",
                        field: "currency.currencyCode",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Permanently Deleted In",
                        field: "DeletedAt",
                        body: (rowData) => (
                          <React.Fragment>
                            {calculateDaysBetweenDate(
                              DateTime.fromISO(rowData.DeletedAt).plus({
                                years: 1,
                              }),
                              DateTime.now()
                            )}{" "}
                            Days
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Actions",
                        body: (rowData) => (
                          <React.Fragment>
                            <BootstrapTooltip title="Restore Outlet">
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.handleRestoreOutlet(rowData);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-restore"></i>
                              </button>
                            </BootstrapTooltip>
                          </React.Fragment>
                        ),
                        sortable: false,
                      },
                    ]}
                  />
                </TabPanel>
                <TabPanel header="Warehouses" rightIcon="fas fa-warehouse">
                  <CustomDataTable
                    data={warehouses}
                    dataDetailColumns={warehouseDetailColumn}
                    onRefreshData={() => {
                      this.getRecycleBinData();
                    }}
                    columns={[
                      {
                        header: "Warehouse ID",
                        field: "ID",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Deleted Status",
                        field: "deletedStatus",
                        body: (rowData) => (
                          <React.Fragment>
                            <Badge variant="danger">Soft Deleted</Badge>
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Warehouse Name",
                        field: "warehouseName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.warehouseName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Phone Number",
                        field: "addressPhone",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.addressPhone}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "City",
                        field: "city",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.city}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Permanently Deleted In",
                        field: "DeletedAt",
                        body: (rowData) => (
                          <React.Fragment>
                            {calculateDaysBetweenDate(
                              DateTime.fromISO(rowData.DeletedAt).plus({
                                years: 1,
                              }),
                              DateTime.now()
                            )}{" "}
                            Days
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Actions",
                        body: (rowData) => (
                          <React.Fragment>
                            <BootstrapTooltip title="Restore Warehouse">
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.handleRestoreWarehouse(rowData);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-restore"></i>
                              </button>
                            </BootstrapTooltip>
                          </React.Fragment>
                        ),
                        sortable: false,
                      },
                    ]}
                  />
                </TabPanel>
                <TabPanel header="Items" rightIcon="fas fa-boxes">
                  <CustomDataTable
                    data={items}
                    dataDetailColumns={itemDetailColumn}
                    onRefreshData={() => {
                      this.getRecycleBinData();
                    }}
                    columns={[
                      {
                        header: "Item ID",
                        field: "ID",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Deleted Status",
                        field: "deletedStatus",
                        body: (rowData) => (
                          <React.Fragment>
                            <Badge variant="danger">Soft Deleted</Badge>
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Item Type",
                        field: "itemTypeName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemTypeName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Item Code",
                        field: "itemCode",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemCode}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Item Name",
                        field: "itemName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Base Unit",
                        field: "itemUom.uomName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemUom.uomName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Brand Name",
                        field: "itemBrand.brandName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemBrand.brandName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Permanently Deleted In",
                        field: "DeletedAt",
                        body: (rowData) => (
                          <React.Fragment>
                            {calculateDaysBetweenDate(
                              DateTime.fromISO(rowData.DeletedAt).plus({
                                years: 1,
                              }),
                              DateTime.now()
                            )}{" "}
                            Days
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Actions",
                        body: (rowData) => (
                          <React.Fragment>
                            <BootstrapTooltip title="Restore Item">
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.handleRestoreItem(rowData);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-restore"></i>
                              </button>
                            </BootstrapTooltip>
                          </React.Fragment>
                        ),
                        sortable: false,
                      },
                    ]}
                  />
                </TabPanel>
                <TabPanel header="Vendors" rightIcon="fas fa-handshake">
                  <CustomDataTable
                    data={vendors}
                    dataDetailColumns={vendorDetailColumn}
                    onRefreshData={() => {
                      this.getRecycleBinData();
                    }}
                    columns={[
                      {
                        header: "Vendor ID",
                        field: "ID",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Deleted Status",
                        field: "deletedStatus",
                        body: (rowData) => (
                          <React.Fragment>
                            <Badge variant="danger">Soft Deleted</Badge>
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Vendor Name",
                        field: "vendorName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.vendorName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Phone Number",
                        field: "contactPhone",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.contactPhone}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "City",
                        field: "city",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.city}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Permanently Deleted In",
                        field: "DeletedAt",
                        body: (rowData) => (
                          <React.Fragment>
                            {calculateDaysBetweenDate(
                              DateTime.fromISO(rowData.DeletedAt).plus({
                                years: 1,
                              }),
                              DateTime.now()
                            )}{" "}
                            Days
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Actions",
                        body: (rowData) => (
                          <React.Fragment>
                            <BootstrapTooltip title="Restore Vendor">
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.handleRestoreVendor(rowData);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-restore"></i>
                              </button>
                            </BootstrapTooltip>
                          </React.Fragment>
                        ),
                        sortable: false,
                      },
                    ]}
                  />
                </TabPanel>
                <TabPanel header="Users" rightIcon="fas fa-user">
                  <CustomDataTable
                    data={users}
                    dataDetailColumns={userDetailColumn}
                    onRefreshData={() => {
                      this.getRecycleBinData();
                    }}
                    columns={[
                      {
                        header: "User ID",
                        field: "ID",
                        body: null,
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Deleted Status",
                        field: "deletedStatus",
                        body: (rowData) => (
                          <React.Fragment>
                            <Badge variant="danger">Soft Deleted</Badge>
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Full Name",
                        field: "fullName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.fullName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "UserName",
                        field: "username",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.username}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "User Group",
                        field: "userGroup.groupName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.userGroup.groupName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Authorization",
                        field: "authorization.authName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.authorization.authName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Permanently Deleted In",
                        field: "DeletedAt",
                        body: (rowData) => (
                          <React.Fragment>
                            {calculateDaysBetweenDate(
                              DateTime.fromISO(rowData.DeletedAt).plus({
                                years: 1,
                              }),
                              DateTime.now()
                            )}{" "}
                            Days
                          </React.Fragment>
                        ),
                        sortable: true,
                        filter: true,
                      },
                      {
                        header: "Actions",
                        body: (rowData) => (
                          <React.Fragment>
                            <BootstrapTooltip title="Restore User">
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.handleRestoreUser(rowData);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-restore"></i>
                              </button>
                            </BootstrapTooltip>
                          </React.Fragment>
                        ),
                        sortable: false,
                      },
                    ]}
                  />
                </TabPanel>
              </TabView>
            </div>
          </div>
        </ContentLayout>
      </React.Fragment>
    );
  }

  handleRestoreCustomer = (customer) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to restore this Customer ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, restore it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          restoreCustomer(customer.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Restored",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getRecycleBinData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleRestoreLead = (lead) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to restore this Lead ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, restore it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          restoreLead(lead.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Restored",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getRecycleBinData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleRestoreOutlet = (outlet) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to restore this Outlet ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, restore it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          restoreOutlet(outlet.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Restored",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getRecycleBinData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleRestoreWarehouse = (warehouse) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to restore this Warehouse ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, restore it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          restoreWarehouse(warehouse.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Restored",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getRecycleBinData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleRestoreItem = (item) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to restore this Item ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, restore it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          restoreItem(item.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Restored",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getRecycleBinData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleRestoreVendor = (vendor) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to restore this Vendor ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, restore it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          restoreVendor(vendor.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Restored",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getRecycleBinData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleRestoreUser = (user) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to restore this User ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, restore it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          restoreUser(user.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Restored",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getRecycleBinData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleReloadRecycleBin = () => {
    this.getRecycleBinData();
  };
}

export default withGlobalData(RecycleBin);
